<template>
  <div class="buttons bottom-button">
    <img src="../../assets/images/desktop/tab_01_active.svg" class="type_1 active" alt="" @click="emit_change(0)" />
    <img
      v-if="step_status[1] == false && current_step !== 1 && current_step !== 2"
      src="../../assets/images/desktop/layout_icon_2.svg"
      class="type_3"
      alt=""
    />
    <img
      v-else
      src="../../assets/images/desktop/tab_02_active.svg"
      class="type_3 active"
      alt=""
      @click="emit_change(1)"
    />
    <img
      v-if="step_status[2] == false && current_step !== 3"
      src="../../assets/images/desktop/layout_icon_3.svg"
      class="type_2"
      alt=""
    />
    <img
      v-else
      src="../../assets/images/desktop/tab_03_active.svg"
      class="type_2 active"
      alt=""
      @click="emit_change(3)"
    />
    <img
      v-if="step_status[3] == false && current_step !== 4 && current_step !== 5"
      src="../../assets/images/desktop/layout_icon_4.svg"
      class="type_3"
      alt=""
    />
    <img
      v-else
      src="../../assets/images/desktop/tab_04_active.svg"
      class="type_3 active"
      alt=""
      @click="emit_change(4)"
    />
    <img
      v-if="step_status[4] == false && current_step < 6"
      src="../../assets/images/desktop/layout_icon_5.svg"
      class="type_3"
      alt=""
    />
    <img
      v-else
      src="../../assets/images/desktop/tab_05_active.svg"
      class="type_3 active"
      alt=""
      @click="emit_change(6)"
    />
  </div>
</template>

<style lang="scss" scoped>
.buttons {
  width: 6.5rem;
  border-radius: 3.25rem;
  background-color: $main_header_middle;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  img {
    margin: 1.6rem 0;
    height: auto;

    &.active {
      cursor: pointer;
    }

    &.type_1 {
      width: 3rem;
      max-width: 3rem;
    }

    &.type_2 {
      width: 3.5rem;
      max-width: 3.5rem;
    }

    &.type_3 {
      width: 4rem;
      max-width: 4rem;
    }
  }
}
</style>

<script>
export default {
  props: ["step_status", "current_step"],
  methods: {
    emit_change: function (step) {
      this.$emit("step-changed", step);
    },
  },
};
</script>
